import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute } from '@angular/router';
import { PktrAppMenuService } from '@prospektr/pktr-app-menu';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { PaginatedBackendResponse } from 'src/app/_shared/interface/common.interface';
import { MultiSelectOption } from 'src/app/_shared/interface/multi-select.interface';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import { ValidatorsService } from 'src/app/shared/service/validators.service';
import constants from 'src/constant.json';
import { ClientDashboardService } from '../../service/client-dashboard.service';
import { ClientDashboardState } from '../../state/client-dashboard.state';
import { SelectSearchDropdownComponent } from '../select-search-dropdown/select-search-dropdown.component';

interface activeClientList {
  clientName: string;
  email: string;
  phoneNumber: number;
  connectedOn: string;
  leadType: string;
  leadStatus: string;
  leadCaptureDate: string;
}

@Component({
  providers: [SelectSearchDropdownComponent],
  selector: 'app-active-clients',
  templateUrl: './active-clients.component.html',
  styleUrls: ['./active-clients.component.scss'],
})
export class ActiveClientsComponent implements OnInit, OnDestroy {
  JSON = JSON;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('inviteInvestorDialog', { static: true }) inviteInvestorDialog: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('clientListContainer') clientListContainer: ElementRef;

  @Output() optionEvent = new EventEmitter();
  @Output() setDeafultFilter = new EventEmitter();

  @Input() filterToApply;
  constant: any = constants;
  investorUsersCount: number;
  agentIdList: Array<any>;
  clientNameList: Array<any>;
  canViewLoanOfficer: boolean;
  clientFilterForm: FormGroup = this.formBuilder.group({
    duration: ['12', Validators.pattern('[0-9]*')],
    durationType: ['month'],
    agentId: [null],
    verificationStatus: ['all'],
    searchClients: [''],
    leadStatus: [''],
  });
  clientUserFetchParams = { userType: 'agent', limit: 20, offset: 0, searchQuery: null };
  investorFetchParams = { orderBy: 'createdDate', orderType: 'desc', limit: 10, offset: 0 };
  dialogRef: any;
  investorInviteForm: FormGroup;
  isDataLoading: boolean = false;
  isDisableFilterBtn = false;
  isDisableResetBtn = false;
  isInvitingInvestor: boolean = false;
  Math: Math = Math;
  partnershipDetails = [];
  clearSearch = 'hide';
  tableDataSource = new MatTableDataSource<activeClientList>([]);
  tableColumnList: string[] = [
    'clientName',
    'email',
    'totalActivityScore',
    'lastActivityDate',
    'activationDate',
    'leadType',
    'source',
    'leadStatus',
    'emailVerificationDate',
    'createdDate',
  ];
  emailVerificationDate: any;
  verificationStatus: any;
  requestData: { limit: number; offset: number; orderBy: string; orderType: string; filter: any } = {
    limit: this.investorFetchParams.limit,
    offset: this.investorFetchParams.offset,
    orderBy: this.investorFetchParams.orderBy,
    orderType: this.investorFetchParams.orderType,
    filter: {},
  };
  userRole: string;
  singleSelectEvent?: any;
  isClientFormValid: boolean = true;
  reset = [];
  optionLength: number;
  selectedDurationType?: any;
  selectDuration: any;
  selectedVerificationStatus: any;
  user: any;
  pageSize: any;
  pageIndex: number;
  companyStatus: boolean = false;
  loginState: boolean = false;
  isTrailPlan: boolean;
  multiSelectOptions: MultiSelectOption[] = [];
  selectedOptions: Array<string>;
  hasMoreClientUsers: boolean = true;
  exportingInProgress: boolean = false;
  leadFilter: any[];
  // Subscription to unsubscribe on component destroy
  onDestroyNotifier$ = new Subject();
  isHourDurationValid: boolean = true;
  isMinuteDurationValid: boolean = true;
  inputValue: any = 12;
  pattern = /^[0-9]+$/;
  filterFlag: boolean = false;
  oldDurationValue: any;
  oldDurationTypeValue: any;
  fetchData: boolean = false;
  email: any;
  investorParamsId: any;

  constructor(
    private clientDashboardService: ClientDashboardService,
    public clientDashboardState: ClientDashboardState,
    private dialog: MatDialog,
    public formBuilder: FormBuilder,
    public authorizeService: AuthorizeService,
    private userState: UserState,
    public appState: AppState,
    private route: ActivatedRoute,
    public _pktrAppMenuService: PktrAppMenuService,
    public breakpointService: ValidatorsService
  ) { }
  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      this.investorParamsId = params.get('id');
    });
    const variable = this.route.snapshot.queryParamMap.get('variable');
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        this.fetchData = true;
      }
    });
    this.route.queryParams.subscribe((params) => {
      this.email = params['email'];
    });
    if (this.email) {
      this.clientFilterForm?.get('searchClients').setValue(this.email);
      this.filterData();
    }
    if (this.fetchData) {
      this.fetchActivePartners();
      this.fetchInvestorUsers();
    }
    this.appState.companyInfo$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res?.type == 'default') {
        this.tableColumnList.push('connectionStatus');
      }
      this.leadFilter = [
        {
          name: 'Buyer',
          items: res.buyerLeadCategory,
          type: 'buyer',
        },
        {
          name: 'Seller',
          items: res.sellerLeadCategory,
          type: 'seller',
        },
      ];
    });
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      this.userRole = res?.roles?.[0];
    });

    this.clientDashboardState.investorList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((investorList: any) => {
      if (investorList && investorList.length) {
        investorList.forEach((result) => {
          if (result._id == this.investorParamsId) {
            this.openClientDetailsSheet(result);
          }
          result.tag = this.clientDashboardService.getStatusTag(result.leadType, result.leadStatus);
          return;
        });
      }
      this.tableDataSource = new MatTableDataSource(investorList);
    });

    this.clientDashboardState.investorListCount$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((count) => {
      this.investorUsersCount = count;
    });

    this.clientDashboardState.clientUserList$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((clientUserList: PaginatedBackendResponse) => {
        if (this.clientUserFetchParams.offset == 0) this.multiSelectOptions = [];
        this.multiSelectOptions = JSON.parse(
          JSON.stringify(
            clientUserList?.data?.reduce((filtered, client) => {
              if (client.userType == 'agent')
                filtered.push({
                  displayText: `${client.firstName} ${client.lastName}`,
                  value: client._id,
                } as MultiSelectOption);
              return filtered;
            }, this.multiSelectOptions) || []
          )
        );
        if (clientUserList?.data?.length != 0 && clientUserList?.data?.length == clientUserList?.totalCount) {
          this.hasMoreClientUsers = false;
        }
        if (clientUserList?.data?.length) this.clientUserFetchParams.offset += 20;
      });

    this.clientDashboardState.activePartnerList$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((partnershipList: any) => {
        this.partnershipDetails = partnershipList;
      });

    if (this.userRole == 'loanOfficer') {
      this.clientDashboardService
        .getAgentId()
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe((res: any) => { });

      this.clientDashboardState.activeAgentList$
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe((agentList: any) => {
          this.agentIdList = agentList;
        });
    }

    if (this.authorizeService.canView('clientUsers')) {
      this.loginState = true;
      this.clientDashboardService
        .fetchAgentsAndLoanOfficers(this.clientUserFetchParams)
        .pipe(takeUntil(this.onDestroyNotifier$))
        .subscribe((res: any) => { });
    }

    this.investorInviteForm = this.formBuilder.group({
      firstName: [
        '',
        Validators.compose([Validators.maxLength(25), Validators.pattern('[a-zA-Z ]*'), Validators.required]),
      ],
      lastName: ['', Validators.pattern('[a-zA-Z ]*')],
      email: ['', [Validators.required, Validators.pattern(constants.regex.validEmail)]],
      phone: ['', Validators.pattern('^(\\+\\d{1,2}\\s?)?1?\\-?\\.?\\s?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$')],
    });
  }

  ngOnChanges() {
    this.oldDurationValue = this.clientFilterForm.controls.duration.value;
    this.oldDurationTypeValue = this.clientFilterForm.controls.durationType.value;
    if (this.filterToApply && this.filterToApply.length) {
      if (this.filterToApply == 'isActive') {
        this.resetPaginatorAndFetchClients('minutes', '5');
      } else if (this.filterToApply == 'isRecentlyActive') {
        this.resetPaginatorAndFetchClients('hours', '8');
      } else {
        this.resetFilter();
      }
    }
  }

  resetPaginatorAndFetchClients(durationType, duration): void {
    this.clearSearch = '';
    this.selectedOptions = null;
    this.clientFilterForm.reset();
    this.paginator.pageIndex = 0;
    this.leadStatusCtrl.reset();
    this.investorFetchParams = { orderBy: 'createdDate', orderType: 'desc', limit: 10, offset: 0 };
    this.clientFilterForm?.get('duration').setValue(duration);
    this.clientFilterForm?.get('durationType').setValue(durationType);
    this.fetchInvestorUsers();
  }

  fetchActivePartners() {
    this.clientDashboardService
      .fetchActivePartners()
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.isDataLoading = res.isLoading;
      });
  }

  fetchInvestorUsers() {
    let requestData: any = {
      limit: this.investorFetchParams.limit,
      offset: this.investorFetchParams.offset,
      orderBy: this.investorFetchParams.orderBy,
      orderType: this.investorFetchParams.orderType,
      filter: {},
      searchClients: this.filterFlag ? this.clientFilterForm.value.searchClients : '',
    };

    if (!this.filterFlag && this.oldDurationValue && this.oldDurationTypeValue) {
      requestData.filter.activeAfterDate = moment().subtract(this.oldDurationValue, this.oldDurationTypeValue).toDate();
    } else if (this.filterFlag && this.filterDurationCtrl.value && this.filterDurationTypeCtrl.value) {
      requestData.filter.activeAfterDate = moment()
        .subtract(this.filterDurationCtrl.value, this.filterDurationTypeCtrl.value)
        .toDate();
    } else {
      delete requestData.filter.activeAfterDate;
    }

    if (
      (this.filterAgentIdCtrl?.value == 'all' || this.filterAgentIdCtrl?.value == null) &&
      !this.selectedOptions?.length
    ) {
      delete requestData.filter.agentIdList;
    } else {
      if (this.filterAgentIdCtrl.value) requestData.filter.agentIdList = [this.filterAgentIdCtrl.value];
      else if (this.selectedOptions?.length) requestData.filter.agentIdList = this.selectedOptions;
    }

    if (this.leadStatusCtrl?.value?.length) {
      requestData.filter.leadStatus = {};
      if (this.filterFlag) {
        this.leadStatusCtrl?.value.forEach((leadStatus) => {
          if (requestData.filter.leadStatus[leadStatus.type]) {
            requestData.filter.leadStatus[leadStatus.type].push(leadStatus.value);
          } else {
            requestData.filter.leadStatus[leadStatus.type] = [leadStatus.value];
          }
        });
      }
    }

    if (this.filterVerificationStatusCtrl.value == 'true' || this.filterVerificationStatusCtrl.value == 'false') {
      requestData.filter.verificationStatus = this.filterFlag ? this.filterVerificationStatusCtrl.value : '';
    } else {
      delete requestData.filter.verificationStatus;
    }

    if (!Object.keys(requestData.filter).length) {
      delete requestData.filter;
    }
    this.clientDashboardService
      .fetchInvestors(requestData)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.isDataLoading = res.isLoading;
      });
  }

  setAsDefaultPartner(connectionId) {
    this.clientDashboardService
      .setAsDefaultPartner({
        connId: connectionId,
      })
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.fetchActivePartners();
      });
  }

  sortTable(sortState: Sort) {
    this.paginator.pageIndex = 0;
    this.investorFetchParams.limit;
    this.investorFetchParams.offset = 0;
    this.investorFetchParams.orderBy = sortState.active;
    this.investorFetchParams.orderType = sortState.direction;
    this.fetchInvestorUsers();
  }

  pageChange(event) {
    if (this.investorFetchParams.offset != event.pageSize * event.pageIndex) {
      this.investorFetchParams.limit = event.pageSize;
      this.investorFetchParams.offset = event.pageSize * event.pageIndex;
    } else {
      this.investorFetchParams.limit = event.pageSize;
      this.paginator.pageIndex = 0;
      this.investorFetchParams.offset = 0;
    }

    this.fetchInvestorUsers();
    this.clientListContainer.nativeElement.scrollTop = 0;
  }

  openClientDetailsSheet(clientDetails) {
    this.breakpointService
      .isMobileOrTablet()
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((isMobileOrTablet) => {
        if (isMobileOrTablet) {
          this._pktrAppMenuService.close(true);
        }

      });

    this.clientDashboardState.activeClientDetailsValue = clientDetails;
    this.clientDashboardState.openClientDetailsSheetValue = true;
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  openInviteDialogBox() {
    this.dialogRef = this.dialog.open(this.inviteInvestorDialog);
  }

  closeDialog() {
    this.investorInviteForm.reset();
    this.dialogRef.close();
  }

  inviteUser() {
    if (this.investorInviteForm.invalid) {
      return;
    }
    const formData = this.investorInviteForm.value;
    const inviteInfo = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email.toLowerCase(),
      phone: formData.phone,
      type: 'investor',
    };
    this.clientDashboardService
      .inviteInvestor(inviteInfo)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(({ isLoading }: any) => {
        this.isInvitingInvestor = isLoading;
        if (!isLoading) {
          this.investorInviteForm.reset();
          this.dialogRef.close();
        }
      });
  }

  resetFilter() {
    this.filterFlag = false;
    this.clearSearch = '';
    this.selectedOptions = null;
    this.leadStatusCtrl.reset();
    this.clientFilterForm?.get('durationType').setValue('month');
    this.clientFilterForm?.get('duration').setValue('12');
    this.clientFilterForm?.get('verificationStatus').setValue('all');
    this.clientFilterForm?.get('searchClients').setValue('');
    this.investorFetchParams.limit = 10;
    this.investorFetchParams.offset = 0;
    this.investorFetchParams.orderBy = 'lastActivityDate';
    this.investorFetchParams.orderType = 'desc';
    this.paginator.pageSize = 10;
    this.paginator.pageIndex = 0;
    this.clientFilterForm.get('agentId').setValue(null);
    if (this.loginState == true) {
      this.multiSelectOptions = JSON.parse(JSON.stringify(this.multiSelectOptions));
    }
    this.fetchInvestorUsers();
    setTimeout(() => {
      this.clearSearch = 'hide';
    });
    this.clientUserFetchParams.searchQuery = null;
    this.clientUserFetchParams.offset = 0;
    this.clientDashboardService
      .fetchAgentsAndLoanOfficers(this.clientUserFetchParams)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => { });
  }

  fetchNextClientUserList() {
    this.clientDashboardService
      .fetchAgentsAndLoanOfficers(this.clientUserFetchParams)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        if (res?.data && !res.data?.data?.length) this.hasMoreClientUsers = false;
      });
  }

  searchClientUser(searchText: string) {
    this.hasMoreClientUsers = true;
    this.clientUserFetchParams.offset = 0;
    this.clientUserFetchParams.searchQuery = searchText;
    this.fetchNextClientUserList();
  }

  getSourceValueWithoutFrom(source: string): string {
    const value = this.constant.SIGN_UP.sourceValue[source];
    return value ? value.replace(/^From\s+/i, '') : '';
  }

  filterData() {
    if (!this.isClientFormValid) return;
    this.filterFlag = true;
    if (this.paginator?.pageIndex) {
      this.paginator.pageIndex = 0;
      this.investorFetchParams.limit = 10;
      this.investorFetchParams.offset = 0;
    }
    this.fetchInvestorUsers();
  }

  updateSelectedOptions($event: Array<MultiSelectOption>) {
    if (!$event?.length || $event?.length == this.multiSelectOptions.length) return (this.selectedOptions = null);
    this.selectedOptions = $event?.map((option) => option.value);
  }

  singleSelect($event) {
    this.singleSelectEvent = $event;
  }

  restrictAlphabets(event) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  readyToExport() {
    this.exportingInProgress = true;
    let requestData: any = {
      orderBy: this.investorFetchParams.orderBy,
      orderType: this.investorFetchParams.orderType,
      filter: {},
      searchClients: this.clientFilterForm.value.searchClients,
    };

    if (this.filterDurationCtrl.value && this.filterDurationTypeCtrl.value) {
      requestData.filter.activeAfterDate = moment()
        .subtract(this.filterDurationCtrl.value, this.filterDurationTypeCtrl.value)
        .toDate();
    } else {
      delete requestData.filter.activeAfterDate;
    }

    if (
      (this.filterAgentIdCtrl?.value == 'all' || this.filterAgentIdCtrl?.value == null) &&
      !this.selectedOptions?.length
    ) {
      delete requestData.filter.agentIdList;
    } else {
      if (this.filterAgentIdCtrl.value) requestData.filter.agentIdList = [this.filterAgentIdCtrl.value];
      else if (this.selectedOptions?.length) requestData.filter.agentIdList = this.selectedOptions;
    }

    if (this.leadStatusCtrl?.value?.length) {
      requestData.filter.leadStatus = {};
      this.leadStatusCtrl?.value.forEach((leadStatus) => {
        if (requestData.filter.leadStatus[leadStatus.type]) {
          requestData.filter.leadStatus[leadStatus.type].push(leadStatus.value);
        } else {
          requestData.filter.leadStatus[leadStatus.type] = [leadStatus.value];
        }
      });
    }

    if (this.filterVerificationStatusCtrl.value == 'true' || this.filterVerificationStatusCtrl.value == 'false') {
      requestData.filter.verificationStatus = this.filterVerificationStatusCtrl.value;
    } else {
      delete requestData.filter.verificationStatus;
    }

    if (!Object.keys(requestData.filter).length) {
      delete requestData.filter;
    }

    this.clientDashboardService
      .exportMyClientsToCSV(requestData)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res) => {
        if (res && res.data) {
          let delimitedText = res.data.investorsDetails;
          let csvName = res.data.csvName ? res.data.csvName + '.csv' : 'investorsList.csv';
          let csvData = new Blob([delimitedText], {
            type: 'text/csv;charset=utf-8;',
          });
          let csvURL = window.URL.createObjectURL(csvData);
          let downloadFile = document.createElement('a');
          downloadFile.href = csvURL;
          downloadFile.setAttribute('download', csvName);
          downloadFile.click();
          this.exportingInProgress = false;
        }
      });
  }

  onDurationTypeChange() {
    const durationControl = this.clientFilterForm.get('duration');
    const durationTypeControl = this.clientFilterForm.get('durationType');

    if (durationTypeControl.value === 'hours') {
      const durationValue = durationControl.value;
      if (durationValue < 1 || durationValue > 24) {
        this.isHourDurationValid = false;
      } else {
        this.isHourDurationValid = true;
      }
    } else if (durationTypeControl.value === 'minutes') {
      const durationValue = durationControl.value;
      if (durationValue < 1 || durationValue > 59) {
        this.isMinuteDurationValid = false;
      } else {
        this.isMinuteDurationValid = true;
      }
    } else if (!this.pattern.test(this.clientFilterForm.get('duration').value)) {
      this.isHourDurationValid = false;
      this.isMinuteDurationValid = false;
    } else {
      this.isHourDurationValid = true;
      this.isMinuteDurationValid = true;
    }

    durationControl.updateValueAndValidity();
  }

  onInputChange() {
    if (this.clientFilterForm.get('durationType').value == 'hours') {
      if (this.inputValue >= 1 && this.inputValue <= 24) {
        this.isHourDurationValid = true;
      } else {
        this.isHourDurationValid = false;
      }
    } else if (this.clientFilterForm.get('durationType').value == 'minutes') {
      if (this.inputValue >= 1 && this.inputValue <= 59) {
        this.isMinuteDurationValid = true;
      } else {
        this.isMinuteDurationValid = false;
      }
    } else if (!this.pattern.test(this.clientFilterForm.get('duration').value)) {
      this.isHourDurationValid = false;
      this.isMinuteDurationValid = false;
    } else {
      this.isHourDurationValid = true;
      this.isMinuteDurationValid = true;
    }
  }

  get formControls() {
    return this.investorInviteForm.controls;
  }

  public get filterDurationCtrl(): FormControl {
    return this.clientFilterForm.controls.duration as FormControl;
  }

  public get leadStatusCtrl(): FormControl {
    return this.clientFilterForm.controls.leadStatus as FormControl;
  }

  public get filterDurationTypeCtrl(): FormControl {
    return this.clientFilterForm.controls.durationType as FormControl;
  }

  public get filterAgentIdCtrl(): FormControl {
    return this.clientFilterForm.controls.agentId as FormControl;
  }

  public get filterVerificationStatusCtrl(): FormControl {
    return this.clientFilterForm.controls.verificationStatus as FormControl;
  }
}
